import { Grid, styled } from '@mui/material'
import { getModalStyle } from '../../../../utils'

export const StyledWrap = styled(Grid)(({ theme }) => ({
  display: 'flex',
  maxWidth: theme.spacing(23),
  marginLeft: 'auto',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'left',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: 'unset',
  },
}))

export const ModalContent = styled(Grid)(({ theme }) => ({
  ...getModalStyle(),
  maxWidth: theme.spacing(64),
  maxHeight: '90vh',
  minHeight: theme.spacing(37.5),
  overflow: 'hidden',
  outline: 'none',
  position: 'absolute',
  width: '100%',
  display: 'flex',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  [theme.breakpoints.up('sm')]: {
    maxWidth: theme.spacing(64),
  },
  [theme.breakpoints.down('xs')]: {
    maxWidth: '90%',
    marginTop: theme.spacing(6.25),
  },
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(3.75),
  },
}))

export const ModalBody = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  overflowY: 'auto',
  maxHeight: 'calc(90vh - 100px)',
  margin: theme.spacing(1.25, 0, 3),
  '& .MuiGrid-grid-sm-8': {
    maxWidth: '100%',
    flexBasis: '100%',
  },
}))
